<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <gg-toolbar @close="close">
        Rename Database
      </gg-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-alert type="warning" class="py-1">
              It is a potentially dangerous operation to rename a MySQL database. You may want to
              back up this database before renaming it.
            </v-alert>
            <p class="mb-0">Old name: <strong>{{ database.db }}</strong></p>
          </v-col>
          <v-col cols="12" class="pt-0">
            <gg-text-field
              label="New Name"
              name="New Name"
              v-model="name"
              :prefix="namePrefix"
              :counter="maxlength"
              required
              v-validate="`required|max:${maxlength}`"
              :error-messages="errors.collect('New Name')"></gg-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <gg-btn class="mb-0" secondary @click="close">Cancel</gg-btn>
        <gg-btn
          :loading="loading"
          class="mb-0"
          @click="renameDatabase"
        >
          Rename
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RenameDatabaseModal',
  props: {
    database: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      loading: false,
      name: '',
    }
  },
  computed: {
    ...mapGetters({
      hosting: 'hosting',
      mysqlRestrictions: 'mysql/mysqlRestrictions'
    }),
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
    namePrefix () {
      return this.mysqlRestrictions ? this.mysqlRestrictions.prefix : ''
    },
    maxlength () {
      if (typeof this.mysqlRestrictions.max_database_name_length !== 'undefined') {
        if (typeof this.mysqlRestrictions.prefix !== 'undefined') {
          return this.mysqlRestrictions.max_database_name_length - this.mysqlRestrictions.prefix.length
        }
        return this.mysqlRestrictions.max_database_name_length
      }
      return 64
    },
    newName () {
      return this.namePrefix + this.name
    }
  },
  methods: {
    ...mapActions({
      renameMysqlDatabase: 'mysql/renameMysqlDatabase',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    close () {
      this.$emit('close')
    },
    async renameDatabase () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      const newname = this.newName
      const oldname = this.database.db
      const _username = this.$route.query.user
      try {
        await this.renameMysqlDatabase({ newname, oldname, _username })
        this.reportSuccess(`Database “${oldname}” renamed to “${newname}”.`)
        this.loading = false
        this.$emit('action-completed')
        this.close()
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    },
  },
}
</script>
